import JRDivHTMLElement from './JRDivHTMLElement';

if (!customElements.get('jr-div')) {
    customElements.define('jr-div', JRDivHTMLElement);
}
